export default (NodeManager => {
  Object.assign(NodeManager.prototype, {
    treeToMap(tree, org_id, first = true, del = false, wait = false, ret = null) {
      if (!("p" in tree)) tree.p = null;
      if (!("x" in tree)) tree.x = null;
      if (!("j" in tree)) tree.j = null;
      if (ret === null) ret = {};
      if (tree.p in ret && ret[tree.p].iH || this.isHide(tree._prop || {})) {
        ret[tree.id] = {
          o: org_id,
          n: tree.id,
          c: null,
          e: {},
          f: del ? 2 : wait ? 1 : 0,
          j: tree.j,
          p: tree.p,
          s: null,
          v: 0,
          x: tree.x,
          iH: 1
        };
      } else {
        ret[tree.id] = {
          ...tree,
          _children: undefined,
          o: org_id,
          n: tree.id,
          e: tree._prop || {},
          d: null,
          f: del ? 2 : wait ? 1 : 0,
          g: 'gd',
          h: tree._prop._sys_createTime,
          i: tree._prop._sys_creator,
          c: tree._children.length > 0 ? tree._children[0].id : null,
          s: tree._children.length > 0 ? tree._children[tree._children.length - 1].id : null,
          m: 0,
          // 修改时间
          me: null,
          // 状态结束时间
          mg: [],
          // 参与者
          ms: null,
          // 状态开始时间
          mu: null,
          // 负责人
          p: tree.p,
          q: null,
          // 模板id
          r: 0,
          // 模板状态
          t: tree._title,
          // 标题
          v: 0 // 版本号
        };
        if (tree._color) {
          ret[tree.id].e._sys_color = tree._color;
        }
        if (tree._document._cover) {
          if ("_sys_cover" in ret[tree.id].e) {
            ret[tree.id].e._sys_cover = [...ret[tree.id].e._sys_cover, ...tree._document._cover];
          } else {
            ret[tree.id].e._sys_cover = tree._document._cover;
          }
        }
        if (tree._actions.length > 0) {
          ret[tree.id].e._sys_actions = tree._actions;
        } else {
          ret[tree.id].e._sys_actions = [];
        }
      }
      for (let i = 0; i < tree._children.length; i++) {
        tree._children[i].p = tree._children[i]._delete && !del ? org_id.toLowerCase() + 'dd' : tree.id;
        tree._children[i].x = i > 0 ? tree._children[i - 1].id : null;
        tree._children[i].j = i < tree._children.length - 1 ? tree._children[i + 1].id : null;
        this.treeToMap(tree._children[i], org_id, false, del || tree._children[i]._delete, wait || tree._children[i]._nodeType === 2, ret);
      }
      return ret;
    },
    getToBeSortId(tree) {
      for (let i = 0; i < tree._children.length; i++) {
        if (tree._children[i]._nodeType === 2) return tree._children[i].id;
      }
      for (let i = 0; i < tree._children.length; i++) {
        const temp = this.getToBeSortId(tree._children[i]);
        if (temp !== null) return temp;
      }
      return null;
    }
  });
});